export default "__VITE_ASSET__o_Mb0jG0__"